module.exports = __webpack_public_path__ + "img/FIRE.116ffb07.jpg";